// The Mao's gender (male / female). It decides who the Mao may marry (docs/MARRIAGE-PLAN.md), so it is chosen ONCE and the server locks the first value.
//   • adoption asks for it (ui/onboardingPanel.js → profile.gender → the server locks it when the game is first saved)
//   • a Mao adopted before this existed is asked once, at the next sign-in (ui/genderPrompt.js)
//   • if the server already holds a gender it wins: the game adopts it (a modified save cannot change it)

import { Events, on, emit } from '../ui/eventBus.js'
import { getProfile, persist } from './state.js'
import { getAccountInfo, lockMyGender } from './accountManager.js'

const VALID = new Set(['MALE', 'FEMALE'])
let asked = false

export function reconcileGender() {
  const acct = getAccountInfo()
  const p = getProfile()
  if (!acct.loggedIn || !acct.online || !p?.onboarded) return
  if (VALID.has(acct.gender)) { // the server's value is the truth
    if (p.gender !== acct.gender) { p.gender = acct.gender; persist() }
    return
  }
  if (VALID.has(p.gender)) { // chosen at adoption: lock it now
    lockMyGender(p.gender).then((r) => { if (VALID.has(r?.gender) && p.gender !== r.gender) { p.gender = r.gender; persist() } }).catch(() => { /* the next sign-in tries again */ })
    return
  }
  if (!asked) { asked = true; emit(Events.NeedGender, {}) }
}

// The player picks (from the prompt). Returns the locked gender.
export async function chooseGender(g) {
  const r = await lockMyGender(g)
  const p = getProfile()
  if (VALID.has(r?.gender)) { p.gender = r.gender; persist() }
  return r
}

on(Events.AccountReady, () => setTimeout(reconcileGender, 800)) // (after the saved game has been adopted)
on(Events.AccountStatePulled, () => setTimeout(reconcileGender, 800))
on(Events.OnboardingComplete, () => setTimeout(reconcileGender, 1500))
